// Admin.js
import React from 'react';
import AdminTools from './AdminTools';
import './Users.css';


const AdminApp = () => (
    <div>
        <h1 className='text-3xl font-bold underline'>Admin</h1>
        {/* <Users/> */}
        <AdminTools/>
    </div>
);


export default AdminApp;

